import { Box, Flex, Image, Link } from '@chakra-ui/react';
import { refineUrlDomain } from '@eternal/Components/Utility/utils';
import NextLink from 'next/link';
/**
 *
 * @param {Object} props
 * @returns
 */
const Header = props => {
  return (
    <Box as="header" height="auto" w="100%" bg="rgba(7, 7, 7, 0.52)" {...props}>
      <Box
        maxW={1200}
        w={{ base: '95%', lg: '90%' }}
        mx="auto"
        className="header-container"
        py={{ base: '12px', lg: '17px' }}
        height={{ base: '55px', md: '100px' }}
      >
        <Flex justifyContent="space-between" maxW={1200} w="100%" mx="auto">
          <NextLink href={refineUrlDomain('/', '', '')}>
            <Link>
              <Image
                priority
                src="https://static.sadhguru.org/d/46272/1663673930-sadhguru_signature_white.svg"
                alt="Sadhguru's signature"
                width={{ base: 67, md: 117 }}
              />
            </Link>
          </NextLink>
          <NextLink href={refineUrlDomain('#')}>
            <Link cursor="pointer">
              <Box
                as="iframe"
                cursor="pointer"
                src="https://lottie.host/embed/3963da62-1a03-4065-aef7-c4244d6245e5/nd0HsJFpIl.json"
                width="55px"
                height={{ base: '32px', md: '55px' }}
              />
            </Link>
          </NextLink>
        </Flex>
      </Box>
    </Box>
  );
};
export default Header;
